<script>
export default {
  name: 'tce-transporter-module',
};
</script>

<style lang="scss">
@import '../../styles/style.scss';
@import 'TceTransporterModule';
</style>
